import React from 'react';
import { useParams } from 'react-router-dom';

import HomeCMS from './HomeCMS';
import CareerCMS from './CareerCMS';
import AboutCMS from './AboutCMS';
import ProjectCMS from './ProjectCMS';
import ContactCMS from './ContactCMS';

const CMSWrapper = () => {
    const { code } = useParams();

    switch (code) {
        case 'home':
            return <HomeCMS />;
        case 'about':
            return <AboutCMS />;
        case 'project':
            return <ProjectCMS />;
        case 'contact':
            return <ContactCMS />;
        case 'career':
            return <CareerCMS />;
        default:
            return <div>Invalid CMS page: <strong>{code}</strong></div>;
    }
};

export default CMSWrapper;
